(function () {
  'use strict';

  var instances = new Map();

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function destroyInstance(id) {
    var inst = instances.get(id);
    if (!inst) return;
    if (inst.onResize) window.removeEventListener('resize', inst.onResize);
    instances.delete(id);
  }

  function boot(root) {
    if (!root || root.dataset.lpFaqReady === 'true') return;

    var sectionId = root.getAttribute('data-section-id') || '';
    destroyInstance(sectionId);

    var allowMultiple = root.getAttribute('data-allow-multiple') === 'true';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-lp-faq-item]'));
    if (!items.length) return;

    root.dataset.lpFaqReady = 'true';

    function getPanel(item) {
      return item.querySelector('[data-lp-faq-panel]');
    }

    function getTrigger(item) {
      return item.querySelector('[data-lp-faq-trigger]');
    }

    function measurePanel(panel) {
      panel.style.height = 'auto';
      var height = panel.scrollHeight;
      return height;
    }

    function setPanelClosed(panel) {
      panel.style.height = '0px';
      panel.style.opacity = '0';
      panel.style.transform = 'translateY(-4px)';
      panel.setAttribute('hidden', '');
    }

    function setPanelOpen(panel, animate) {
      var height = measurePanel(panel);
      panel.removeAttribute('hidden');

      if (!animate || prefersReducedMotion()) {
        panel.style.height = height + 'px';
        panel.style.opacity = '1';
        panel.style.transform = 'translateY(0)';
        return;
      }

      panel.style.height = height + 'px';
      panel.style.opacity = '1';
      panel.style.transform = 'translateY(0)';
    }

    function closeItem(item, animate) {
      var panel = getPanel(item);
      var trigger = getTrigger(item);
      if (!panel || !trigger) return;

      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');

      if (!animate || prefersReducedMotion()) {
        setPanelClosed(panel);
        return;
      }

      var currentHeight = panel.scrollHeight;
      panel.style.height = currentHeight + 'px';
      panel.offsetHeight;
      panel.style.height = '0px';
      panel.style.opacity = '0';
      panel.style.transform = 'translateY(-4px)';

      panel.addEventListener('transitionend', function onEnd(e) {
        if (e.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onEnd);
        if (!item.classList.contains('is-open')) {
          panel.setAttribute('hidden', '');
        }
      });
    }

    function openItem(item, animate) {
      var panel = getPanel(item);
      var trigger = getTrigger(item);
      if (!panel || !trigger) return;

      if (!allowMultiple) {
        items.forEach(function (other) {
          if (other !== item && other.classList.contains('is-open')) {
            closeItem(other, animate);
          }
        });
      }

      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');

      if (!animate || prefersReducedMotion()) {
        setPanelOpen(panel, false);
        return;
      }

      panel.removeAttribute('hidden');
      panel.style.height = '0px';
      panel.style.opacity = '0';
      panel.style.transform = 'translateY(-4px)';
      panel.offsetHeight;
      setPanelOpen(panel, true);
    }

    items.forEach(function (item) {
      var panel = getPanel(item);
      var trigger = getTrigger(item);

      if (item.classList.contains('is-open')) {
        panel.removeAttribute('hidden');
        panel.style.height = measurePanel(panel) + 'px';
        panel.style.opacity = '1';
        panel.style.transform = 'translateY(0)';
        trigger.setAttribute('aria-expanded', 'true');
      } else {
        setPanelClosed(panel);
        trigger.setAttribute('aria-expanded', 'false');
      }

      trigger.addEventListener('click', function () {
        if (item.classList.contains('is-open')) {
          closeItem(item, true);
        } else {
          openItem(item, true);
        }
      });
    });

    function onResize() {
      items.forEach(function (item) {
        if (!item.classList.contains('is-open')) return;
        var panel = getPanel(item);
        panel.style.height = measurePanel(panel) + 'px';
      });
    }

    window.addEventListener('resize', onResize);
    instances.set(sectionId, { root: root, onResize: onResize });

    root._lpFaqRebuild = function () {
      destroyInstance(sectionId);
      root.dataset.lpFaqReady = 'false';
      boot(root);
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lp-faq]').forEach(boot);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector('[data-lp-faq]');
    if (!el && e.target && e.target.matches('[data-lp-faq]')) el = e.target;
    if (el) {
      el.dataset.lpFaqReady = 'false';
      boot(el);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target && e.target.querySelector('[data-lp-faq]');
    if (!el && e.target && e.target.matches('[data-lp-faq]')) el = e.target;
    if (el) {
      destroyInstance(el.getAttribute('data-section-id') || '');
      el.dataset.lpFaqReady = 'false';
    }
  });

  document.addEventListener('shopify:block:select', function () {
    document.querySelectorAll('[data-lp-faq]').forEach(function (root) {
      if (root._lpFaqRebuild) root._lpFaqRebuild();
    });
  });
})();
